import React from "react";

import { IAdditionalInfoFormContent } from "./AdditionalInfoFormContent";
import { Appearance, Vocal, Dancing, Twin, Makeup } from "./sections";
import { BasicInfoViewModel, FacetsViewModel } from "../../../models/views";

import "./AdditionalInfoForm.scss";

interface IAdditionalInfoFormProps {
  model: BasicInfoViewModel;
  facets: FacetsViewModel;
  applyChanges: (model: BasicInfoViewModel) => void;
  content: IAdditionalInfoFormContent;
}

interface IAdditionalInfoFormState {
  isShownContent: boolean;
}

export class AdditionalInfoForm extends React.Component<
  IAdditionalInfoFormProps,
  IAdditionalInfoFormState
> {
  constructor(props: IAdditionalInfoFormProps) {
    super(props);

    this.state = {
      isShownContent: false,
    };
  }

  public render() {
    const { isShownContent } = this.state;
    const { facets, model, content } = this.props;

    return (
      isShownContent && (
        <div className="c-additional-info-form">
          <Appearance
            content={content}
            model={model}
            facets={facets}
            handleChanges={this.applyChanges}
          />
          <Makeup model={model} handleChanges={this.applyChanges} />
          <Vocal
            maxYearValue={99}
            minYearValue={0}
            content={content}
            model={model}
            facets={facets}
            handleChanges={this.applyChanges}
          />
          <Dancing
            content={content}
            model={model}
            handleChanges={this.applyChanges}
          />
          <Twin
            content={content}
            model={model}
            handleChanges={this.applyChanges}
          />
        </div>
      )
    );
  }

  public componentDidMount() {
    this.setState({ isShownContent: true });
  }

  private applyChanges = (model: BasicInfoViewModel) =>
    this.props.applyChanges(model);
}

export default AdditionalInfoForm;
